import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.poweredBy}>
            powered by <span className={styles.author}>Sergey Lozovskoy</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
